<template>
  <div>
    <v-card>
      <UserList
        has-search
        ref="userList"
        header-title="Users"
        :with-priority="true"
        :show-select="true"
        :users="subscriptionUsers"
        :loading="loading"
        :disabled="deleting || saving"
        :error-message="error"
        :add-user-action="onClickAddNewUser"
        :selected-users-action="onClickDelete"
        @change-priority="onChangePriority"

      />
    </v-card>
    <v-dialog scrollable :value="inviteModal" persistent :fullscreen="$vuetify.breakpoint.smAndDown" max-width="60vw">
      <InviteUsersComponent :on-close="onCloseInviteModal"/>
    </v-dialog>
  </div>
</template>

<script>
import UserList from '../UserList'
import InviteUsersComponent from './InviteUsersComponent'
import bulkOperation from '../../mixins/bulkOperation'

export default {
  name: 'SubscriptionUsersList',
  mixins: [bulkOperation],
  components: {
    UserList,
    InviteUsersComponent
  },
  props: ['subscriptionUsers', 'loading', 'error', 'subscriptionId'],
  data: () => ({
    deleting: false,
    saving: false,
    inviteModal: false,
    selected: [],
    search: '',
    headers: [
      {
        text: 'Email',
        align: 'left',
        value: 'email'
      }
    ]
  }),
  methods: {
    onChangePriority: function (user) {
      this.saving = true
      this.$store.dispatch('subscription/savePriority', user.id)
        .then(res => {
          this.saving = false
          this.$refs.userList.resetData()
        })
        .catch(err => {
          console.error(err)
          user.prioritized = !user.prioritized
          this.saving = false
          this.$refs.userList.resetData()
        })
    },

    onClickAddNewUser: function () {
      this.inviteModal = true
    },

    onCloseInviteModal: function () {
      this.inviteModal = false
    },

    onClickDelete: function (selectedUsers) {
      let removeSubscriptionAccessPromises = selectedUsers.map(user => this.$store.dispatch('subscription/removeSubscriptionAccess', { user: { id: user.id, email: user.email }, subscription: { id: this.subscriptionId, alias: this.unitAlias } }))
      this.executeBulkOperation(removeSubscriptionAccessPromises)
    },

    beforeBulk: function () {
      this.deleting = true
      this.$refs.userList.setSelectedUsersLoading()
    },

    handleBulkError: function (error) {
      console.error(error)
    },

    handleBulkSuccess: function (responses) {
      if (responses.length <= 0) {

      } else {
        let userIds = responses.map(e => e.user.id)
        this.$store.dispatch('subscription/removeUsersFromSubscription', userIds)
        let emailsString = ''
        for (let response of responses) {
          emailsString += response.user.email + ', '
        }

        emailsString = emailsString.substr(0, emailsString.length - 2)
        this.$store.commit('setSuccessMessage', emailsString + ' has been removed from the subscription')
      }
    },

    afterBulk: function () {
      this.deleting = false
      this.$refs.userList.resetData()
    }
  },
  computed: {
    unitAlias: function () {
      return this.$store.state.subscription.currentSubscriptionUnit.alias
    }
  }
}
</script>

<style scoped>

</style>
